import {
  BankOutlined,
  CloudUploadOutlined,
  DatabaseOutlined,
  TeamOutlined,
  UnorderedListOutlined,
  BarChartOutlined,
  DeploymentUnitOutlined,
} from "@ant-design/icons";
import { Layout, Menu } from "antd";
import * as PropTypes from "prop-types";
import React, { useCallback, useState } from "react";
import { FormattedMessage } from "react-intl";
import { connect } from "react-redux";
import styled from "styled-components";
// import Cookies from "universal-cookie";

import store, { history } from "../../store";

import { actions as NAVIGATION_ACTIONS, selectors as NAVIGATION_SELECTORS } from "../../ducks/navigation";

import NavigationLayoutRoutes from "../NavigationLayoutRoutes";
import PageHeader from "../PageHeader";

import About from "../About";
import NodesList from "../NodesList";
// import TutorialsModal from "../TutorialsModal";
// import JoinOrganizationModal from "../JoinOrganizationModal";
import useRole from "../../hooks/useRole";
import GlobalErrorBoundaries from "../ErrorBoundaries/GlobalErrorBoundaries";
import Header from "../Header";
import NavigationQSHub from "../NavigationQSHub";

const { Content, Sider } = Layout;
const { SubMenu, Item } = Menu;
// const cookies = new Cookies();

const NavigationLayout = ({ activeKey, activeSubmenu }) => {
  const { isAdmin } = useRole();
  const [collapsed, setCollapsed] = useState(false);

  const [showAboutModal, setShowAboutModal] = useState(false);
  // const [showTutorialsModal, setShowTutorialsModal] = useState(cookies.get("QuickstreamSkipTutorials") !== "true");

  const handleShowAboutModal = useCallback(() => {
    setShowAboutModal(!showAboutModal);
  }, [showAboutModal]);

  // const handleShowTutorialsModal = useCallback(() => {
  //   setShowTutorialsModal(!showTutorialsModal);
  // }, [showTutorialsModal]);

  const onCollapse = () => {
    setCollapsed(!collapsed);
  };

  const handleNavClick = useCallback((navElement) => {
    store.dispatch(NAVIGATION_ACTIONS.SET_ACTIVE_KEY({ activeKey: [navElement.key] }));
  }, []);

  const handleChangeSubmenu = useCallback((openKeys) => {
    store.dispatch(NAVIGATION_ACTIONS.SET_ACTIVE_SUBMENU({ activeSubmenu: [...openKeys] }));
  }, []);

  return (
    <Layout>
      <Header />
      <Layout hasSider>
        <StyledSider collapsible collapsed={collapsed} onCollapse={onCollapse} width={250}>
          <Menu
            mode="inline"
            theme="dark"
            onClick={handleNavClick}
            selectedKeys={activeKey}
            openKeys={activeSubmenu}
            onOpenChange={handleChangeSubmenu}
          >
            <NavigationQSHub
              activeSubmenu={activeSubmenu}
              handleChangeSubmenu={handleChangeSubmenu}
              activeKey={activeKey}
            />
            {isAdmin && (
              <>
                <Item key="/admin/accounts" onClick={() => history.push("/admin/accounts")}>
                  <TeamOutlined />
                  <span>
                    <FormattedMessage id="userMenu.manageAccounts" defaultMessage="Accounts" />
                  </span>
                </Item>
                <Item key="/licenses" onClick={() => history.push("/licenses")}>
                  <DatabaseOutlined />
                  <span>
                    <FormattedMessage id="userMenu.manageLicense" defaultMessage="All licenses" />
                  </span>
                </Item>
                <Item key="/cloud/licenses" onClick={() => history.push("/cloud/licenses")}>
                  <BarChartOutlined />
                  <span>
                    <FormattedMessage id="userMenu.cloudLicenses" defaultMessage="Cloud licenses" />
                  </span>
                </Item>
                <Item key="/cloud/nodes" onClick={() => history.push("/cloud/nodes")}>
                  <DeploymentUnitOutlined />
                  <span>
                    <FormattedMessage id="userMenu.cloudNodes" defaultMessage="Cloud nodes" />
                  </span>
                </Item>
              </>
            )}
            {!isAdmin && (
              <Item key="/licenses" onClick={() => history.push("/licenses")}>
                <DatabaseOutlined />
                <span>
                  <FormattedMessage id="userMenu.licenses" defaultMessage="Licenses" />
                </span>
              </Item>
            )}
            <Item key="/nodes-management" onClick={() => history.push(`/nodes-management`)}>
              <CloudUploadOutlined />
              <span>
                <FormattedMessage id="userMenu.manageNodes" defaultMessage="Nodes management" />
              </span>
            </Item>
            <SubMenu
              key="/node"
              title={
                <StyledNodesLink>
                  <UnorderedListOutlined />
                  <span>
                    <FormattedMessage id="NodesList.nodesConfiguration" defaultMessage="Nodes configuration" />
                  </span>
                </StyledNodesLink>
              }
            >
              <NodesList />
            </SubMenu>
            <Item key="about" onClick={handleShowAboutModal}>
              <BankOutlined />
              <span>
                <FormattedMessage id="GuestView.about" defaultMessage="About" />
              </span>
            </Item>
          </Menu>
        </StyledSider>
        <Layout>
          <StyledContent $collapsed={collapsed}>
            <PageHeader />
            <GlobalErrorBoundaries>
              <NavigationLayoutRoutes />
            </GlobalErrorBoundaries>
          </StyledContent>
        </Layout>
      </Layout>
      <About handleShowModal={handleShowAboutModal} showModal={showAboutModal} />
      {/* <TutorialsModal
        handleShowTutorialsModal={handleShowTutorialsModal}
        showTutorialsModal={showTutorialsModal}
      /> */}
      {/* <JoinOrganizationModal /> */}
    </Layout>
  );
};

const StyledNodesLink = styled.div`
  color: rgba(255, 255, 255, 0.65);
  &:hover {
    color: #fff;
  }
`;

const StyledSider = styled(Sider)`
  overflow: auto;
  height: calc(100vh - 112px);
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  margin-top: 64px;
`;
const StyledContent = styled(Content)`
  background: #fff;
  padding: 24px;
  margin: 0;
  min-height: 28px;
  margin-left: ${(props) => (props.$collapsed ? "75px" : "250px")};
  transition: margin 200ms ease-in;
`;

NavigationLayout.propTypes = {
  activeKey: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.string]).isRequired,
  activeSubmenu: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.string), PropTypes.array]).isRequired,
};

const mapStateToProps = (state) => ({
  activeKey: NAVIGATION_SELECTORS.getActiveNavKey(state),
  activeSubmenu: NAVIGATION_SELECTORS.getActiveNavSubmenu(state),
});

export default connect(mapStateToProps, null)(NavigationLayout);
